import React from 'react';
import { AuthContext } from '../context';
import { useLocalAuth } from './useLocalAuth';

interface LocalAuthProviderProperties {
  children: React.ReactNode;
}

export const LocalAuthProvider: React.FC<LocalAuthProviderProperties> = ({ children }) => {
  const authService = useLocalAuth();
  return <AuthContext.Provider value={authService}>{children}</AuthContext.Provider>;
};
